import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import I18n from 'I18n';
import { readUnhandledEnumCase } from 'rpc-client-utils';
// @ts-expect-error Could not find a declaration file for module
import inboundImageUrl from 'bender-url!../../../../images/pngs/Inbound2025.png';
import { useGetActiveByLanguageQuery } from '../../../../__generated__/chirp/com/hubspot/academy/studio/rpc/services/AcademyStudioAnnouncementChirpService.hooks';
import getLang from '../../../utils/getLang';
const getHardcodedAnnouncements = () => [{
  id: 1,
  banner: inboundImageUrl,
  title: I18n.text('learningCenter.announcements.inbound2025.title'),
  body: I18n.text('learningCenter.announcements.inbound2025.body'),
  ctaText: I18n.text('learningCenter.announcements.inbound2025.ctaText'),
  ctaUrl: 'https://app.hubspotqa.com/academy/885765335/results?search=Artificial%20Intelligence',
  // eslint-disable-line
  embeddedId: 670967,
  embeddedContentType: 'PLAYLIST',
  language: 'EN'
}];
export function useAnnouncements() {
  // Get current language - getLang() already ensures it's supported
  const currentLanguage = getLang().toUpperCase();
  const {
    data: chirpData,
    error,
    loading
  } = useGetActiveByLanguageQuery({
    variables: {
      language: currentLanguage
    },
    errorPolicy: 'ignore'
  });
  const announcements = chirpData !== null && chirpData !== void 0 && chirpData.response ? [chirpData.response] : getHardcodedAnnouncements();
  const featuredAnnouncement = announcements[0];
  let featuredContentItem = null;
  if (featuredAnnouncement !== null && featuredAnnouncement !== void 0 && featuredAnnouncement.embeddedId && featuredAnnouncement !== null && featuredAnnouncement !== void 0 && featuredAnnouncement.embeddedContentType) {
    const {
      embeddedId,
      embeddedContentType,
      language
    } = featuredAnnouncement;
    featuredContentItem = {
      id: embeddedId,
      type: embeddedContentType,
      language: readUnhandledEnumCase(language)
    };
  }
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: featuredContentItem ? [featuredContentItem] : [],
    skip: !featuredContentItem
  });
  const finalCardModels = cardModels === null || cardModels === void 0 ? void 0 : cardModels.map(cardModel => Object.assign({}, cardModel, {
    previewThumbnailRectangleUrl: inboundImageUrl,
    thumbnailRectangleUrl: inboundImageUrl,
    previewThumbnailSquareUrl: inboundImageUrl,
    thumbnailSquareUrl: inboundImageUrl
  }));
  return {
    announcements: announcements || [],
    error,
    featuredCardModel: (finalCardModels === null || finalCardModels === void 0 ? void 0 : finalCardModels[0]) || null,
    loading: loading || cardModelsLoading,
    cardModelsError
  };
}